import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BellIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BellIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.5525 14.5326V12.0962C15.5525 10.3217 14.2693 8.86326 12.6087 8.72046V8.18227C12.6087 7.89604 12.3758 7.66312 12.0899 7.66312C11.804 7.66312 11.5711 7.89604 11.5711 8.18227V8.72046C9.9108 8.86326 8.62753 10.3217 8.62753 12.0962V14.5326C8.11695 14.7351 7.78027 15.2263 7.78027 15.7822C7.78027 16.5241 8.38382 17.1277 9.12542 17.1277H12.6417L13.1501 17.8506C13.2602 18.0073 13.4093 18.0727 13.5553 18.0727C13.6638 18.0727 13.7708 18.0365 13.859 17.9743C14.0687 17.8271 14.1887 17.5244 13.9983 17.2534L13.9098 17.1277H15.0544C15.7963 17.1277 16.3998 16.5242 16.3998 15.7822C16.3998 15.2263 16.0631 14.7351 15.5525 14.5326ZM11.2014 14.9559C11.2014 14.6697 10.9684 14.4368 10.6825 14.4368H9.66487V12.0962C9.66487 10.8002 10.6391 9.74605 11.8363 9.74605H12.3434C13.5407 9.74605 14.5149 10.8002 14.5149 12.0962V14.4368H13.574C13.2881 14.4368 13.0555 14.6697 13.0555 14.9559C13.0555 15.2415 13.2881 15.4744 13.574 15.4744H15.0543C15.2241 15.4744 15.3622 15.6121 15.3622 15.7822C15.3622 15.9523 15.2241 16.09 15.0543 16.09H9.12542C8.95565 16.09 8.81761 15.9523 8.81761 15.7822C8.81761 15.6121 8.95565 15.4744 9.12542 15.4744H10.6825C10.9685 15.4744 11.2014 15.2415 11.2014 14.9559Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0799 19.5954C21.033 17.7073 22.1506 15.0786 22.1506 12.3604C22.1506 10.0153 21.3262 7.73248 19.8294 5.93197C18.3516 4.15558 16.2963 2.9326 14.0414 2.48898C13.7599 2.43503 13.487 2.61718 13.4324 2.89833C13.4058 3.03415 13.4337 3.1725 13.5108 3.28737C13.5882 3.40224 13.7056 3.4803 13.8414 3.50696C15.8622 3.90425 17.7055 5.00093 19.0316 6.59518C20.3739 8.20974 21.113 10.2571 21.113 12.3604C21.113 14.9878 19.9706 17.4795 17.9791 19.1968L17.9569 19.2216C17.6852 19.6157 17.8496 19.8632 17.9708 19.9749L19.461 21.3838H12.0898C9.68004 21.3838 7.41401 20.4452 5.70965 18.7405C4.00529 17.0365 3.06664 14.7701 3.06664 12.3604C3.06664 10.2571 3.80569 8.20972 5.14798 6.5958C6.47377 5.00092 8.31712 3.90424 10.3385 3.50695C10.4743 3.48029 10.5917 3.40223 10.6688 3.28736C10.7462 3.17185 10.7738 3.03413 10.7472 2.89832C10.7205 2.76187 10.6425 2.64446 10.5273 2.56767C10.4121 2.49024 10.2744 2.46422 10.1382 2.48897C7.88333 2.93259 5.82769 4.15557 4.35054 5.93196C2.85371 7.73247 2.0293 10.0153 2.0293 12.3604C2.0293 15.0481 3.07584 17.574 4.97599 19.4742C6.8755 21.3743 9.40206 22.4209 12.0898 22.4209H20.7642C20.9781 22.4209 21.1672 22.2927 21.2459 22.094C21.3253 21.8954 21.2761 21.6726 21.1206 21.5254L19.0799 19.5954Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.4542 8.3478C8.39169 8.22404 8.28475 8.13202 8.15274 8.08886C8.02168 8.04507 7.88079 8.05649 7.75703 8.11869C7.70182 8.14725 6.40332 8.82823 6.40332 10.5837C6.40332 10.8693 6.63624 11.1022 6.92215 11.1022C7.20806 11.1022 7.44098 10.8693 7.44098 10.5837C7.44098 9.47113 8.19749 9.05925 8.2289 9.04274C8.48117 8.91264 8.5824 8.60102 8.4542 8.3478Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.87202 7.87752C7.12556 7.74869 7.22711 7.43644 7.09891 7.18258C6.96944 6.92745 6.65687 6.82401 6.40174 6.95348C6.33129 6.98902 4.67041 7.85342 4.67041 10.1248C4.67041 10.4111 4.90333 10.644 5.18924 10.644C5.47515 10.644 5.70807 10.4111 5.70807 10.1248C5.70807 8.51536 6.82633 7.90227 6.87202 7.87752Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.4229 8.11934C16.2995 8.05587 16.1579 8.04509 16.0269 8.08951C15.8949 8.13267 15.7879 8.22469 15.7254 8.34845C15.5969 8.60295 15.6994 8.91582 15.9529 9.04465C15.985 9.06115 16.7386 9.46923 16.7386 10.5843C16.7386 10.8699 16.9715 11.1028 17.2575 11.1028C17.5434 11.1028 17.7763 10.8699 17.7763 10.5843C17.7763 8.82887 16.4781 8.1479 16.4229 8.11934Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7777 6.95286C17.654 6.89003 17.5137 6.87924 17.3817 6.92303C17.25 6.96619 17.1431 7.05821 17.0809 7.18133C17.0181 7.30445 17.0073 7.44535 17.0504 7.57672C17.0936 7.70873 17.1856 7.81598 17.31 7.87881C17.3214 7.88516 18.4714 8.49506 18.4714 10.1242C18.4714 10.4104 18.7043 10.6434 18.9902 10.6434C19.2762 10.6434 19.5091 10.4104 19.5091 10.1242C19.5091 7.8566 17.8485 6.98904 17.7777 6.95286Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BellIcon;
